import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const mesApiService = createApi({
  tagTypes: [
    'calendar',
    'fabricationOrder',
    'workCenter',
    'workCenterGroups',
    'Warehouse',
    'WarehouseLocation',
    'Fundido',
  ],
  reducerPath: 'mesApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_BASE_URL}`,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token

      if (!token) {
        return headers
      }

      headers.set('authorization', `Bearer ${token}`)
      return headers
    },
  }),
  endpoints: (build) => ({}),
})
